import { createFileRoute } from "@tanstack/react-router";
import logoUrl from "@/assets/mission-ready-logo.webp";
import { MissionReadyHome } from "@/components/landing/MissionReadyPublicSite";
import { useMarketingPageTracking } from "@/lib/use-engagement";
import { trackFunnel } from "@/lib/funnel";
import { socialMeta } from "@/lib/social-meta";
import { ORG_WEBSITE_JSONLD, softwareApplicationJsonLd } from "@/lib/structured-data";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
  component: Landing,
  head: () => ({
    meta: [
      { title: "Security Guard Management Software & Voice DAR | MissionReady" },
      { name: "description", content: "Manage guard reporting, scheduling, and patrols with MissionReady. Includes Voice DAR, QR checkpoint verification, incident reporting, dispatch, and on-duty GPS." },
      ...socialMeta({
        title: "Security Guard Management Software & Voice DAR | MissionReady",
        description: "Manage guard reporting, scheduling, and patrols with MissionReady. Includes Voice DAR, QR checkpoint verification, incident reporting, dispatch, and on-duty GPS.",
        url: "https://missionready.dev/",
      }),
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: "https://missionready.dev/" },
      { rel: "preload", as: "image", href: logoUrl, fetchPriority: "high" } as never,
    ],
    scripts: [
      ...ORG_WEBSITE_JSONLD,
      softwareApplicationJsonLd({
        name: "MissionReady",
        description: "Security operations platform with Voice DAR reporting, patrol verification, incident reporting, dispatch, and client-ready reporting.",
        url: "https://missionready.dev/",
        featureList: [
          "Voice DAR transcription and verified shift sheets",
          "Original DAR audio retention",
          "Live GPS officer tracking",
          "Signed QR checkpoint tours",
          "Incident reporting",
          "Dispatch operations",
          "Client-ready custom reporting",
        ],
      }),
    ],
  }),
});

function Landing() {
  useMarketingPageTracking();
  useEffect(() => {
    trackFunnel("landing_page_viewed", {}, { once: true });
  }, []);
  return <MissionReadyHome />;
}